// extracted by mini-css-extract-plugin
module.exports = {"rich-text":"RichTextWrapper_rich-text__JRTvI"};